import React, { useState } from "react";
import { useSelector } from "react-redux";
import Modal from "../../../../../components/Modal";
import CloseButton from "../../../../../components/CloseButton";
import SelectedStudentList from "../../../../../components/complex/SelectedStudentList";
import FilteredStudentList from "../../../../../components/complex/FilteredStudentList";
import { showDate } from "../../../../../utils/textUtils";

const StudentSelectionPage = ({
  onClose,
  handleAddStudents,
  selectedStudents,
  setSelectedStudents,
  selectedDate,
}) => {
  const { allStudents } = useSelector((state) => state.student);

  const [filteredStudents, setFilteredStudents] = useState(allStudents);

  const handleFilter = ({ keyword = "", gradeList = [], levelList = [] }) => {
    let studentList = allStudents;

    if (keyword.trim() !== "") {
      studentList = studentList.filter((student) =>
        student.name.includes(keyword)
      );
    }

    studentList = studentList.filter((student) =>
      gradeList.includes(student.grade)
    );

    studentList = studentList.filter((student) =>
      levelList.some((level) => {
        if (level.id === 0) {
          return student.level_list.length === 0;
        }
        return student.level_list.some(
          (studentLevel) => studentLevel.id === level.id
        );
      })
    );

    setFilteredStudents(studentList);
  };

  // 좌측 체크박스 클릭 핸들러
  const handleSelectStudent = (student) => {
    if (selectedStudents.some((s) => s.id === student.id)) {
      setSelectedStudents((prev) => prev.filter((s) => s.id !== student.id));
    } else {
      setSelectedStudents((prev) => [...prev, student]);
    }
  };

  const handleSelectAllStudent = (checked, active = false) => {
    if (checked && active) {
      setSelectedStudents(filteredStudents);
    } else {
      setSelectedStudents([]);
    }
  };

  return (
    <Modal>
      <div
        style={{
          background: "#fff",
          padding: "10px 20px",
          borderRadius: "5px",
          width: "1200px",
          height: "600px",
          position: "relative",
          display: "flex",
          gap: "20px",
        }}
      >
        {/* 좌측 리스트 */}
        <div
          style={{
            flex: 3,
            borderRadius: "5px",
          }}
        >
          <div style={{ padding: "10px", color: "black" }}>
            <div style={{ fontSize: "25px", marginBottom: "5px" }}>
              학생 찾기
            </div>
            <div style={{ fontSize: "18px" }}>
              마감 날짜 : {showDate(selectedDate)}
            </div>
          </div>
          <FilteredStudentList
            filteredStudents={filteredStudents}
            selectedStudents={selectedStudents}
            handleSelectStudent={handleSelectStudent}
            handleSelectAllStudent={handleSelectAllStudent}
            handleFilter={handleFilter}
          />
        </div>

        {/* 우측 리스트 */}
        <div
          style={{
            flex: 1.2,
            borderRadius: "5px",
            padding: "10px",
          }}
        >
          {/* X 버튼 */}
          <CloseButton onClick={onClose} />

          <div
            style={{
              marginTop: "50px",
            }}
          >
            <SelectedStudentList
              selectedStudents={selectedStudents}
              handleAddStudents={handleAddStudents}
              handleSelectAllStudent={handleSelectAllStudent}
              handleSelectStudent={handleSelectStudent}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default StudentSelectionPage;
